import { render, staticRenderFns } from "./LossReasons.vue?vue&type=template&id=5881810e"
import script from "./LossReasons.vue?vue&type=script&lang=js"
export * from "./LossReasons.vue?vue&type=script&lang=js"
import style0 from "./LossReasons.vue?vue&type=style&index=0&id=5881810e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports